export default __webpack_public_path__ + "static/media/Phoria-Logo_YBBG.b6ecee71.png";